import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ReadyForFeedback from './assignment/ReadyForFeedback'
import AssignedTo from './assignment/AssignedTo'

import { isNullOrEmpty } from '../../utils'

export default class AssignmentArea extends Component {
  render() {
    const { handleAssignClick, quest } = this.props

    return (
      <div className="assignment-area">
        {this.renderReadyForFeedback() && (
          <ReadyForFeedback handleClick={handleAssignClick} />
        )}
        {!isNullOrEmpty(quest.assigned_to) && <AssignedTo {...this.props} />}
        <div className="line" />
      </div>
    )
  }

  renderReadyForFeedback() {
    const { isQuestCopyEditorOrQuestAuthorOrQuestManager, quest } = this.props

    return (
      isQuestCopyEditorOrQuestAuthorOrQuestManager &&
      isNullOrEmpty(quest.assigned_to)
    )
  }
}

AssignmentArea.propTypes = {
  quest: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  handleAssignClick: PropTypes.func.isRequired,
  questIsAssignedToUser: PropTypes.bool,
  handleUnassignClick: PropTypes.func.isRequired,
  isQuestCopyEditorOrQuestAuthorOrQuestManager: PropTypes.bool.isRequired
}



// WEBPACK FOOTER //
// ./src/components/quest/AssignmentArea.js